import React from 'react';
import './Islamic.css';
import icon1 from '../../../assets/1-Licensed-&-Regulated-.png';
import icon2 from '../../../assets/2- Dubai-Based.png';
import icon3 from '../../../assets/3- Advanced Trading Platform.png';
import icon4 from '../../../assets/4- Expert Support.png';
import icon5 from '../../../assets/5--Secure-&-Supports-USDT.png';

const translations = {
    en: {
        heroSubtitle: "GivTrade Islamic Trading Account",
        heroTitle: "Built for traders who value integrity, clarity, and performance.",
        heroDescription: "Join the growing wave of Dubai forex traders who trust us for speed, reliability, and transparency.",
        buttonText: "Start forex trading now",
        noSwapsTitle: "No Swaps. No Surprises.",
        noSwapsDesc: "Some accounts melt your gains overnight. Ours doesn’t.",
        benefits: [
            "Swap-Free",
            "0% Commission",
            "VIP from $10,000",
            "Instant USDT Deposits",
            "Tight Spreads from 1.2 pips",
            "Leverage up to 1:200",
        ],
        islamicTitle: "What Makes It Islamic?",
        islamicDesc: [
            "Our Islamic Account is built differently—from the ground up:",
            "A fully Shariah-compliant trading account — no interest, hidden fees, or compromise."
        ],
        vipTitle: "The VIP Room Awaits",
        vipDesc: "If you're ready, the room is open:",
        vipBenefits: [
            "Access premium benefits with $10K+",
            "Personal account manager",
            "Professional-grade tools",
        ],
        ctaTitle: "Get started",
        ctaDesc: "Open your account instantly.",
        ctaBenefits: [
            "Trusted, transparent, and compliant",
            "Local presence with global reach",
            "Fast execution, real-time data",
            "24/5 customer support from experts",
            "Instant USDT deposits, fully encrypted environment"
        ],
        ctaBtn: "Open Your Account"
    },
    ar: {
        heroSubtitle: "حساب التداول الإسلامي من GivTrade",
        heroTitle: "مصمم للمتداولين الذين يقدّرون النزاهة والوضوح والأداء.",
        heroDescription: "انضم إلى الموجة المتزايدة من المتداولين في دبي الذين يثقون بنا للسرعة والشفافية والموثوقية.",
        buttonText: "ابدأ التداول الآن",
        noSwapsTitle: "بدون مقايضات. بدون مفاجآت.",
        noSwapsDesc: "بعض الحسابات تذيب أرباحك ليلاً. حسابنا لا يفعل ذلك.",
        benefits: [
            "بدون فوائد",
            "0% عمولة",
            "VIP من 10,000$",
            "إيداعات فورية بـ USDT",
            "سبريد منخفض من 1.2 نقطة",
            "رافعة مالية حتى 1:200",
        ],
        islamicTitle: "ما الذي يجعله إسلاميًا؟",
        islamicDesc: [
            "تم بناء حسابنا الإسلامي بشكل مختلف تمامًا:",
            "حساب تداول متوافق بالكامل مع الشريعة — بدون فوائد، بدون رسوم خفية، وبدون تنازلات."
        ],
        vipTitle: "غرفة كبار الشخصيات في انتظارك",
        vipDesc: "إذا كنت مستعدًا، فالغرفة مفتوحة:",
        vipBenefits: [
            "الوصول إلى مزايا مميزة من 10,000$+",
            "مدير حساب شخصي",
            "أدوات احترافية"
        ],
        ctaTitle: "ابدأ الآن",
        ctaDesc: "افتح حسابك فوراً.",
        ctaBenefits: [
            "موثوق وشفاف ومتوافق مع الأنظمة",
            "وجود محلي بنطاق عالمي",
            "تنفيذ سريع وبيانات مباشرة",
            "دعم فني 24/5 من خبراء",
            "إيداعات USDT فورية وبيئة مؤمنة بالكامل"
        ],
        ctaBtn: "افتح حسابك"
    }
};

const Islamic = ({ language = 'en' }) => {
    const t = translations[language];

    return (
        <div className='full'>
            <div className='forex-container font-sans text-white'>
                {/* HERO SECTION */}
                <div className="hero-section-Islamic">
                    <div className="hero-overlay" />
                    <div className="hero-content">
                        <p className="hero-subtitle-islamic">{t.heroSubtitle}</p>
                        <h1 className="hero-title">{t.heroTitle}</h1>
                        <p className="hero-description">{t.heroDescription}</p>
                        <button className="hero-button" onClick={() => window.open('https://accounts.giv.trade/register/', '_blank')}>
                            {t.buttonText}
                        </button>
                    </div>
                </div>

                {/* NO SWAPS SECTION */}
                <section className='section component-data-container py-16 grid md:grid-cols-2 gap-12 bg-black px-4'>
                    <div>
                        <h2 className='section-heading'>{t.noSwapsTitle}</h2>
                        <p className='section-title'>{t.noSwapsDesc}</p>
                        <ul className='benefits-list'>
                            {t.benefits.map((item, idx) => <li key={idx}><strong className='benefit-title'>{item}</strong></li>)}
                        </ul>
                    </div>
                </section>

                {/* ISLAMIC SECTION */}
                <section className='section component-data-container py-16 grid md:grid-cols-2 gap-12 bg-black px-4'>
                    <div>
                        <h2 className='section-heading'>{t.islamicTitle}</h2>
                        <ul className='benefits-list'>
                            {t.islamicDesc.map((item, idx) => <li key={idx}><strong className='benefit-title'>{item}</strong></li>)}
                        </ul>
                    </div>
                </section>

                {/* VIP ROOM */}
                <section className='section component-data-container py-16 grid md:grid-cols-2 gap-12 bg-black px-4'>
                    <div>
                        <h2 className='section-heading'>{t.vipTitle}</h2>
                        <p className='section-title'>{t.vipDesc}</p>
                        <ul className='benefits-list'>
                            {t.vipBenefits.map((item, idx) => <li key={idx}><strong className='benefit-title'>{item}</strong></li>)}
                        </ul>
                    </div>
                </section>

                {/* CTA SECTION */}
                <section className='section'>
                    <div className='cta-box text-center'>
                        <h3 className='cta-title'>{t.ctaTitle}</h3>
                        <p className='cta-description'>{t.ctaDesc}</p>
                        <ul className='cta-benefits'>
                            {[icon1, icon3, icon2, icon4, icon5].map((icon, idx) => (
                                <li className='cta-lable flex flex-col items-center gap-1 text-center' key={idx}>
                                    <img src={icon} alt='Check' className='icon' />
                                    {t.ctaBenefits[idx]}
                                </li>
                            ))}
                        </ul>
                        <button
                            className='cta-button mx-auto block'
                            onClick={() => window.open('https://accounts.giv.trade/register/', '_blank')}
                        >
                            {t.ctaBtn}
                        </button>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Islamic;
